<script setup lang="ts">
interface AppRawButtonEmits {
  (eventName: 'click', event: MouseEvent): void;
}

const emit = defineEmits<AppRawButtonEmits>();
</script>

<template>
  <button @click="(event) => emit('click', event)">
    <slot />
  </button>
</template>

<style scoped lang="scss">
button {
  all: unset;
  box-sizing: border-box;
}
</style>
